import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EdpLoaderModule } from "@edp-components/edp-loader/edp-loader.module";
import { NgbNavModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { EdpPipesModule } from "src/app/@pipes/edp-pipes.module";
import { EdpOverlayNotificationsComponent } from "./edp-overlay-notifications.component";
import { EdpENotificationCardModule } from "@edp-components/edp-e-notification-card/edp-e-notification-card.module";
import { EdpInputToogleModule } from "@edp-components/edp-input-toogle/edp-input-toogle.module";

@NgModule({
    declarations: [EdpOverlayNotificationsComponent],
    imports: [
        CommonModule,
        TranslateModule,
        EdpLoaderModule,
        NgbNavModule,
        EdpPipesModule,
        EdpENotificationCardModule,
        EdpInputToogleModule,
    ],
    exports: [EdpOverlayNotificationsComponent],
})
export class EdpOverlayNotificationsModule {}
